import createEnum from 'lib/createEnum';

export const quickActionTypes = createEnum('INTERNAL', 'EXTERNAL');

export default {
  quickActionTypes,
};
